export function isXAxis(orient) {
    return "bottom" === orient || "top" === orient;
}

export function isYAxis(orient) {
    return "left" === orient || "right" === orient;
}
//# sourceMappingURL=orient.js.map
